import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useSettings } from "@/lib/settings";

export default function ContactPage() {
  const { settings } = useSettings();

  return (
    <div className="max-w-5xl mx-auto px-5 lg:px-8 py-16">
      <div className="text-xs uppercase tracking-[0.2em] text-eagle-gold font-semibold mb-3">Contact</div>
      <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mb-4">Get in touch with Eagle Eye.</h1>
      <p className="text-muted-foreground max-w-2xl mb-10">Speak to a local Brisbane tech, get a fixed quote, or arrange a site walk-through.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="p-8">
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="h-11 w-11 rounded-full bg-eagle-gold/15 text-eagle-gold flex items-center justify-center shrink-0"><Phone className="h-5 w-5" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest text-muted-foreground">Phone</div>
                {settings?.business_phone ? (
                  <a href={`tel:${settings.business_phone}`} className="font-display text-lg font-semibold hover:text-eagle-gold transition-colors" data-testid="contact-phone">{settings.business_phone}</a>
                ) : (
                  <div className="font-display text-lg font-semibold text-muted-foreground">Not set yet — add in Admin → Settings</div>
                )}
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="h-11 w-11 rounded-full bg-eagle-gold/15 text-eagle-gold flex items-center justify-center shrink-0"><Mail className="h-5 w-5" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest text-muted-foreground">Email</div>
                {settings?.business_email ? (
                  <a href={`mailto:${settings.business_email}`} className="font-display text-lg font-semibold hover:text-eagle-gold transition-colors break-all" data-testid="contact-email">{settings.business_email}</a>
                ) : (
                  <div className="font-display text-lg font-semibold text-muted-foreground">Not set yet — add in Admin → Settings</div>
                )}
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="h-11 w-11 rounded-full bg-eagle-gold/15 text-eagle-gold flex items-center justify-center shrink-0"><MapPin className="h-5 w-5" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest text-muted-foreground">Service Area</div>
                <div className="font-display text-lg font-semibold" data-testid="contact-address">{settings?.business_address || "Brisbane, QLD, Australia"}</div>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="h-11 w-11 rounded-full bg-eagle-gold/15 text-eagle-gold flex items-center justify-center shrink-0"><Clock className="h-5 w-5" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest text-muted-foreground">Hours</div>
                <div className="font-display text-lg font-semibold" data-testid="contact-hours">{settings?.business_hours || "Mon–Sat · 7am–6pm"}</div>
                <div className="text-xs text-muted-foreground">24/7 monitoring &amp; emergency response</div>
              </div>
            </div>
          </div>
        </Card>
        <Card className="p-8 bg-eagle-ink text-white">
          <div className="text-xs uppercase tracking-widest text-eagle-gold font-semibold mb-3">Fastest way</div>
          <h2 className="font-display text-3xl font-bold mb-4">Request a fixed quote</h2>
          <p className="text-white/70 mb-6">Upload photos of your property — we&apos;ll return a marked-up camera plan within 24 hours.</p>
          <Link to="/quote"><Button className="rounded-full bg-eagle-gold text-eagle-ink hover:bg-eagle-goldHover px-6 h-11 font-semibold" data-testid="contact-quote-btn">Start My Quote</Button></Link>
        </Card>
      </div>
    </div>
  );
}